export const normalizeString = (string: string) => {
  return string.normalize("NFC").replace(/['’‘´`ʼ]/g, "'");
};
